import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import AddSubscription from "../modals/AddSubscription";
import Button from "../reusable_components/Button";
import { title ,btnOneNoWidth} from "../utils/style";
import formatNumberToUs from "../custom_functions/formatNumberToUs";


function Subscriptions() {
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)

    const options = [
        {
            header: 'Name',
            key: 'name'
        },
        {
            header: 'Price',
            render: (data) => { return `$${formatNumberToUs(data.price?.toFixed(2))}` },
            filterKey: 'price'
        },
        {
            header: 'Validity',
            render: (data) => { return `${data.validity}  Months` },
            filterKey: 'validity'
        },
        {
            header: 'Free Visits',
            key: 'freeVisits'
        },
        {
            header: 'Add-Ons',
            render: (data) => { return data.addOns },
        }
    ]

    const excludeFilter = ['Logo', 'Add-Ons']

    return (
        <div>
            {
                showForm && <AddSubscription setShowForm={setShowForm} reload={setReloadTable} />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Subscriptions</div>
                {(
                    <Button className={`${btnOneNoWidth}`} name={`Add Subscription`} clickHandler={() => setShowForm(!showForm)} />
                )}
            </div>
            <Table
                options={options}
                url={url + '/subscriptions'}
                pagination
                clickHandler={() => setShowForm(!showForm)}
                btnTitle={'Subscription'}
                excludeFilter={excludeFilter}
                reloadTable={reloadTable}
                noButton={true}
            />
        </div>
    )
}

export default Subscriptions;